import i18n from 'i18n/config';

export const getHelpLink = () => {
  const locale = i18n.language;

  return `https://support.unmind.com/${locale.toLowerCase()}`;
};
